(() => {
  if (window.acCraftConnected) return;
  window.acCraftConnected = true;
  const key = 'ac-saved-artworks';
  const saved = () => { try { const value = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(value) ? value : []; } catch { return []; } };
  const refresh = () => document.querySelectorAll('[data-craft-save]').forEach(button => button.setAttribute('aria-pressed', String(saved().includes(button.dataset.craftSave))));
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-craft-save]');
    if (!button) return;
    const id = button.dataset.craftSave, items = saved();
    try { localStorage.setItem(key, JSON.stringify(items.includes(id) ? items.filter(value => value !== id) : [...items, id])); refresh(); }
    catch { button.setAttribute('aria-label', 'Saving is unavailable in this browser'); }
  });
  window.addEventListener('storage', refresh);
  class CraftPDP extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-craft-variants]')?.textContent || '[]');
      this.labels = JSON.parse(this.querySelector('[data-craft-labels]')?.textContent || '{}');
      this.form = this.querySelector('product-form form');
      this.querySelector('[data-craft-variant]')?.addEventListener('change', event => this.select(event.target.value));
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-craft-thumb]');
        if (thumb) this.media(thumb.dataset.craftThumb);
        const choice = event.target.closest('[data-craft-choice]');
        if (choice) this.select(choice.dataset.craftChoice);
        const step = event.target.closest('[data-craft-quantity-step]');
        if (step) {
          const input = this.form.querySelector('[name="quantity"]');
          const increment = Number(input.step) || 1, min = Number(input.min) || 1, max = input.max ? Number(input.max) : Infinity;
          input.value = String(Math.min(max, Math.max(min, (Number(input.value) || min) + Number(step.dataset.craftQuantityStep) * increment)));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      const initial = this.variants.find(item => String(item.id) === this.form?.querySelector('[name="id"]')?.value);
      if (initial) { this.selected = initial; this.update(initial); }
      const moveEstimate = () => {
        const estimate = this.querySelector('.ot-estimated-shipping');
        const target = document.querySelector('[data-craft-delivery-estimate]');
        if (estimate && target) target.append(estimate);
      };
      this.observer = new MutationObserver(moveEstimate);
      this.observer.observe(this.querySelector('.ac08-purchase'), { childList: true, subtree: true });
      moveEstimate();
      refresh();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    media(id) {
      if (!this.querySelector(`[data-craft-media="${id}"]`)) return;
      this.querySelectorAll('[data-craft-media]').forEach(item => {
        item.hidden = item.dataset.craftMedia !== String(id);
        if (item.hidden) item.querySelectorAll('video').forEach(video => video.pause());
      });
      this.querySelectorAll('[data-craft-thumb]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.craftThumb === String(id))));
    }
    select(id) {
      const variant = this.variants.find(item => String(item.id) === String(id));
      if (!variant || !this.form) return;
      const previousVariant = this.selected?.raw;
      const input = this.form.querySelector('[name="id"]');
      input.value = variant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      const selector = this.querySelector('[data-craft-variant]');
      if (selector) selector.value = variant.id;
      this.update(variant);
      this.selected = variant;
      if (variant.media) this.media(variant.media);
      const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
      this.form.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { formId: this.form.getAttribute('id'), variant: variant.raw, previousVariant } }));
    }
    update(variant) {
      this.querySelector('[data-craft-price]').textContent = variant.price;
      const compare = this.querySelector('[data-craft-compare]');
      compare.hidden = !variant.compare; compare.textContent = variant.compare || '';
      const dimensions = this.querySelector('[data-craft-variant-dimensions]');
      if (dimensions) { dimensions.hidden = !variant.dimensions; dimensions.textContent = variant.dimensions || ''; }
      const button = this.form.querySelector('button[type="submit"]');
      if (button) { button.disabled = !variant.available; button.textContent = variant.available ? this.labels.add : this.labels.sold; }
      const payment = this.querySelector('[data-craft-payment]');
      if (payment) payment.hidden = !variant.available;
      this.querySelectorAll('[data-craft-choice]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.craftChoice === String(variant.id))));
      const quantity = this.form.querySelector('[name="quantity"]');
      quantity.min = variant.minimum || 1; quantity.step = variant.increment || 1;
      if (variant.maximum) quantity.max = variant.maximum; else quantity.removeAttribute('max');
      quantity.value = Math.max(Number(quantity.min), Math.min(Number(quantity.value) || 1, variant.maximum || Infinity));
    }
  }
  class CraftTabs extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(tab));
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.select(this.tabs[next]); this.tabs[next].focus();
        });
      });
    }
    select(selected) {
      this.tabs.forEach(tab => {
        const active = tab === selected;
        tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1;
        const panel = this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`);
        if (panel) panel.hidden = !active;
      });
    }
  }
  if (!customElements.get('ac-craft-pdp')) customElements.define('ac-craft-pdp', CraftPDP);
  if (!customElements.get('ac-craft-tabs')) customElements.define('ac-craft-tabs', CraftTabs);
  const layout = root => {
    const grid = root.querySelector('[data-craft-grid]');
    if (!grid) return;
    const style = getComputedStyle(grid), row = parseFloat(style.gridAutoRows), gap = parseFloat(style.rowGap) || 0;
    if (!Number.isFinite(row) || row <= 0) return;
    grid.querySelectorAll('.ac-craft-card').forEach(card => {
      card.style.gridRowEnd = 'auto';
      card.style.gridRowEnd = `span ${Math.ceil((card.getBoundingClientRect().height + gap) / (row + gap))}`;
    });
  };
  const initCatalog = root => {
    if (root.dataset.craftReady) return;
    root.dataset.craftReady = 'true';
    const form = root.querySelector('[data-craft-filter-form]');
    form.dataset.acEnhanced = 'true';
    const open = root.querySelector('[data-craft-filter-open]');
    const close = () => { form.classList.remove('is-open'); open.focus(); };
    open.addEventListener('click', () => { form.classList.add('is-open'); form.querySelector('[data-craft-filter-close]').focus(); });
    form.addEventListener('click', event => { if (event.target.closest('[data-craft-filter-close]')) close(); });
    if (root.dataset.craftFilterSource) {
      fetch(root.dataset.craftFilterSource).then(response => { if (!response.ok) throw new Error('Unavailable'); return response.text(); }).then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nativeForm = doc.querySelector('[data-craft-filter-form]');
        if (!nativeForm?.querySelector('input[name^="filter."]')) return;
        form.replaceChildren(...nativeForm.children);
        form.action = nativeForm.action;
      }).catch(() => {});
    }
    form.addEventListener('keydown', event => {
      if (event.key === 'Escape') close();
      if (event.key === 'Tab' && form.classList.contains('is-open')) {
        const controls = [...form.querySelectorAll('button,input,select')].filter(item => !item.disabled && item.getClientRects().length);
        if (event.shiftKey && document.activeElement === controls[0]) { event.preventDefault(); controls.at(-1)?.focus(); }
        else if (!event.shiftKey && document.activeElement === controls.at(-1)) { event.preventDefault(); controls[0]?.focus(); }
      }
    });
    form.addEventListener('submit', event => {
      event.preventDefault();
      const url = new URL(form.action, location.origin); url.search = new URLSearchParams(new FormData(form)).toString();
      for (const key of ['preview_theme_id', 'view']) { const value = new URL(location.href).searchParams.get(key); if (value) url.searchParams.set(key, value); }
      location.assign(url);
    });
    form.addEventListener('change', event => { if (event.target.matches('input[type="checkbox"],select') && matchMedia('(min-width:750px)').matches) form.requestSubmit(); });
    form.addEventListener('click', event => {
      const button = event.target.closest('[data-craft-clear]');
      if (!button) return;
      button.closest('fieldset').querySelectorAll('input[type="checkbox"]').forEach(input => input.checked = false);
      if (matchMedia('(min-width:750px)').matches) form.requestSubmit();
    });
    root.addEventListener('click', async event => {
      const link = event.target.closest('[data-craft-load-more]');
        if (!link) return;
        if (link.getAttribute('aria-busy') === 'true') { event.preventDefault(); return; }
      event.preventDefault(); link.setAttribute('aria-busy', 'true');
      const status = root.querySelector('[data-craft-load-status]'); status.textContent = 'Loading crafts…';
      try {
        const url = new URL(link.href); url.searchParams.set('section_id', root.dataset.sectionId);
        const response = await fetch(url); if (!response.ok) throw new Error('Request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = doc.querySelector('[data-craft-catalog]');
        const cards = next?.querySelectorAll('[data-craft-product]');
        if (!cards?.length) throw new Error('No products');
        const existing = new Set([...root.querySelectorAll('[data-craft-product]')].map(card => card.dataset.craftProduct));
        const newCards = [...cards].filter(card => !existing.has(card.dataset.craftProduct));
        root.querySelector('[data-craft-grid]').append(...newCards);
        const more = next.querySelector('[data-craft-load-more]');
        if (more) { link.href = more.href; link.removeAttribute('aria-busy'); } else link.remove();
        refresh(); layout(root); status.textContent = `${newCards.length} more crafts loaded.`;
      } catch { link.removeAttribute('aria-busy'); status.textContent = 'Unable to load crafts. Please try again.'; }
    });
    root.addEventListener('load', () => layout(root), true);
    const observer = new ResizeObserver(() => layout(root)); observer.observe(root.querySelector('[data-craft-grid]'));
    document.fonts.ready.then(() => layout(root)); layout(root);
  };
  const start = () => {
    document.querySelectorAll('[data-craft-catalog]').forEach(initCatalog);
    document.querySelectorAll('[data-craft-recommendations-url]').forEach(root => {
      if (root.dataset.craftReady) return;
      root.dataset.craftReady = 'true';
      fetch(root.dataset.craftRecommendationsUrl).then(response => { if (!response.ok) throw new Error('Unavailable'); return response.text(); }).then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const grid = doc.querySelector('.ac-craft-related-grid');
        if (grid?.querySelector('[data-craft-product]')) { root.querySelector('.ac-craft-related-grid').replaceChildren(...grid.children); refresh(); }
      }).catch(() => {});
    });
    refresh();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
